<template>
  <div class="card border-0 shadow-none rounded-1 mb-25">
    <div class="card-body p-xl-40">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0">
                <div class="form-check checkbox">
                  <input class="form-check-input" type="checkbox" id="test_1" />
                  <label class="form-check-label" for="test_1"> NAME </label>
                </div>
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                SHORT NAME
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                BASE UNIT
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                OPERATOR
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                OPERATION VALUE
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 pe-0">
                ACTION
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <div class="d-flex align-items-center product-item">
                  <div class="form-check checkbox style-three me-25">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="test_32"
                    />
                    <label class="form-check-label" for="test_32"> </label>
                  </div>
                  <span class="fs-14 fs-semibold text-optional">Grams</span>
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">g</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Kilogram
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">/</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                1000
              </td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div class="button-group d-flex flex-wrap align-items-center">
                  <a
                    href="javascript:void(0)"
                    class=""
                    title="Edit"
                    data-bs-target="#createModal"
                    data-bs-toggle="modal"
                  >
                    <img src="../../../assets/img/icons/edit.svg" alt="Image" />
                  </a>
                  <a
                    class="delete-btn"
                    data-bs-toggle="offcanvas"
                    href="#deletePopup"
                    role="button"
                    aria-controls="deletePopup"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      alt="Image"
                    />
                  </a>
                </div>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <div class="d-flex align-items-center product-item">
                  <div class="form-check checkbox style-three me-25">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="test_20"
                    />
                    <label class="form-check-label" for="test_20"> </label>
                  </div>
                  <span class="fs-14 fs-semibold text-optional">Piece</span>
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                pc
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Piece
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">\</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">1</td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div class="button-group d-flex flex-wrap align-items-center">
                  <a
                    href="javascript:void(0)"
                    class=""
                    title="Edit"
                    data-bs-target="#createModal"
                    data-bs-toggle="modal"
                  >
                    <img src="../../../assets/img/icons/edit.svg" alt="Image" />
                  </a>
                  <a
                    class="delete-btn"
                    data-bs-toggle="offcanvas"
                    href="#deletePopup"
                    role="button"
                    aria-controls="deletePopup"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      alt="Image"
                    />
                  </a>
                </div>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <div class="d-flex align-items-center product-item">
                  <div class="form-check checkbox style-three me-25">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="test_33"
                    />
                    <label class="form-check-label" for="test_33"> </label>
                  </div>
                  <span class="fs-14 fs-semibold text-optional">Dozens</span>
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                dz
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Piece
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">1</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                12
              </td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div class="button-group d-flex flex-wrap align-items-center">
                  <a
                    href="javascript:void(0)"
                    class=""
                    title="Edit"
                    data-bs-target="#createModal"
                    data-bs-toggle="modal"
                  >
                    <img src="../../../assets/img/icons/edit.svg" alt="Image" />
                  </a>
                  <a
                    class="delete-btn"
                    data-bs-toggle="offcanvas"
                    href="#deletePopup"
                    role="button"
                    aria-controls="deletePopup"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      alt="Image"
                    />
                  </a>
                </div>
              </td>
            </tr>
            <tr>
              <td class="shadow-none fw-normal text-black title ps-0">
                <div class="d-flex align-items-center product-item">
                  <div class="form-check checkbox style-three me-25">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="test_34"
                    />
                    <label class="form-check-label" for="test_34"> </label>
                  </div>
                  <span class="fs-14 fs-semibold text-optional">Kilogram</span>
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                kg
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                Kilogram
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">1</td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">1</td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div class="button-group d-flex flex-wrap align-items-center">
                  <a
                    href="javascript:void(0)"
                    class=""
                    title="Edit"
                    data-bs-target="#createModal"
                    data-bs-toggle="modal"
                  >
                    <img src="../../../assets/img/icons/edit.svg" alt="Image" />
                  </a>
                  <a
                    class="delete-btn"
                    data-bs-toggle="offcanvas"
                    href="#deletePopup"
                    role="button"
                    aria-controls="deletePopup"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      alt="Image"
                    />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row pb-45 align-items-center">
    <div class="col-sm-6">
      <div
        class="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit"
      >
        <span class="fs-13">Showing product per page</span>
        <select class="text-title border-0 fs-14 bg-transparent">
          <option value="0">10</option>
          <option value="1">20</option>
          <option value="2">30</option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 text-sm-end text-center">
      <ul class="page-nav list-style">
        <li>
          <a href="#">
            <img
              src="../../../assets/img/icons/left-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
        <li><a href="#" class="active">1</a></li>
        <li><a href="#">2</a></li>
        <li><a href="#">3</a></li>
        <li>
          <a href="#">
            <img
              src="../../../assets/img/icons/right-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnitList",
};
</script>